@if (displayed) {
  <div class="dialog-body">
    <div class="dialog-scroll">
      <ng-container [ngTemplateOutlet]="dialogTemplate"></ng-container>
    </div>
  </div>
}
@if (displayed) {
  <div class="modal-background"></div>
}
